module.exports = __webpack_public_path__ + "img/qr.8849c5f.svg";